<!--
 * @name: 图片，视频上传展示组件
 * @description: 图片视频h5上传展示组件
 * @author: huizi(huizi.li@shengyc.com)
 * @Date: 2020-03-16 11:02:13
 * @LastEditTime: 2022-02-24 10:32:15
 -->
<template>
    <div class="picture1">
        <!-- 视频 -->
        <div class="pictureOne" v-for="(item, index) in videoArr" :key="'video' + index">
            <div @click="$_deleteVideo(item.imgSrc, index)" class="item">
                <img src="../../assets/images/ic_close_v3.png" alt class="delete_img" />
            </div>
            <div @click="$_videoPlay">
                <div class="videoButton1" ref="button">
                    <img src="../../assets/images/ic_play.png" alt width="25" height="25" />
                </div>
                <!-- ios显示video会有问题，所以进行区分 -->
                <video
                    height="100px"
                    class="videoImgAn"
                    width="100px"
                    ref="video1"
                    v-if="userAgent() == 'Android'"
                >
                    <source :src="item.imgSrc" type="video/mp4" />
                    <!-- <Text>77</Text> -->
                </video>
                <div class="videoImg" v-else>
                    <video height="100px" class="videoImg" width="100px" ref="video1" style="display:none">
                        <source :src="item.imgSrc" type="video/mp4" />
                    </video>
                </div>
            </div>
        </div>
        <!-- 图片 -->
        <div class="pictureOne" v-for="(item, index) in imgArr" :key="'img' + index">
            <div @click="$_deleteImg(item.imgSrc, index)" class="item">
                <img src="../../assets/images/ic_close_v3.png" alt class="delete_img" />
            </div>
            <img class="img1" :src="item.imgSrc" alt @click="$_showCretialsImg(item.imgSrc)" />
        </div>
        <div
            class="picture_default1"
            v-show="imgArr.length + videoArr.length < fileMaxNum"
            @click="$_openPhoto"
        >
            <img class="img" src="../../assets/images/icon_upload.png" alt />
        </div>
        <input
            v-if="userAgent() == 'Android'"
            type="file"
            id="uploadForm"
            @change="$_handleFiles($event)"
            :capture="acceptType ? 'camera' : ''"
            :accept="acceptType"
            ref="upload"
            style="display:none"
        />
        <input
            v-else
            type="file"
            id="uploadForm"
            @change="$_handleFiles($event)"
            ref="uploadios"
            accept="video/* image/*"
            style="display:none"
        />
        <!--  下拉菜单 -->
        <van-action-sheet v-model="showPhoto" :actions="actions" @select="onSelect" />
    </div>
</template>

<script>
import { pathOr, userAgent } from '@/config/Utils'
import Exif from 'exif-js'
import { ImagePreview, Dialog } from 'vant'
export default {
    name: 'PictureList',
    props: {
        actions: {
            type: Array
        },
        acceptIn: {
            type: String
        },
        fileMaxNum: {
            type: Number,
            default: 10
        }
    },
    data() {
        return {
            userAgent: userAgent,
            pathOr: pathOr,
            showPhoto: false,
            acceptType: '', //上传类型
            imgSrc: '',
            file_url: [],
            imgArr: [], //上传图片选择的图片数组
            videoArr: [], //上传图片选择的视频数组
            picValue: [],
            files: {}
        }
    },
    mounted() {},
    watch: {
        imgArr(val) {
            this.$emit('imgArr', val)
        },
        videoArr(val) {
            this.$emit('videoArr', val)
        }
    },
    created() {},
    beforeDestroy() {},
    methods: {
        //视频图片处理
        async $_handleFiles(fileData) {
            let pic = fileData.target.files[0]
            this.imgSrc = URL.createObjectURL(pic)
            let that = this

            if (pic.type.indexOf('image') > -1) {
                that.imgArr.push({
                    imgSrc: this.imgSrc,
                    type: pic.type,
                    name: pic.name,
                    file: pic
                })
            } else if (pic.type.indexOf('video') > -1) {
                if (that.videoArr.length == 1) {
                    Dialog.confirm({
                        title: '温馨提醒',
                        message: '最多可上传1个视频'
                    })
                        .then(() => {
                            // this.videoArr = [];
                        })
                        .catch(() => {
                            // on cancel
                        })
                } else {
                    that.$nextTick(() => {
                        that.videoArr.push({
                            imgSrc: that.imgSrc,
                            type: pic.type,
                            name: pic.name,
                            file: pic
                        })
                    })
                }
            } else {
                this.Toast('仅支持上传图片或视频')
            }

            this.onRead(fileData)
        },
        //菜单选择
        onSelect(item) {
            // 默认情况下，点击选项时不会自动关闭菜单
            // 可以通过 close-on-click-action 属性开启自动关闭
            this.showPhoto = false
            if (item.name == '拍照') {
                this.acceptType = 'image/*'
            } else if (item.name == '录像') {
                this.acceptType = 'video/*'
            } else if (item.name == '从相册选取') {
                this.acceptType = this.acceptIn || ''
            }
            this.$nextTick(() => {
                this.$refs['upload'].click()
            })
        },
        //全屏播放
        $_videoPlay() {
            let video = this.$refs['video1'][0]
            if (video.paused) {
                if (video.requestFullscreen) {
                    video.requestFullscreen()
                } else if (video.mozRequestFullScreen) {
                    video.mozRequestFullScreen()
                } else if (video.webkitRequestFullScreen) {
                    video.webkitRequestFullScreen()
                }
                video.play()
            }
        },
        // 打开菜单
        $_openPhoto() {
            if (this.userAgent() == 'Android') {
                this.showPhoto = true
            } else {
                this.$nextTick(() => {
                    this.$refs['uploadios'].click()
                })
            }
            if (this.$refs.upload) {
                this.$refs.upload.value = ''
            }
        },

        /**
         * 删除图片
         */
        $_deleteImg(imgSrc, index) {
            this.imgArr.splice(index, 1)
        },
        /**
         * 删除视频
         */
        $_deleteVideo(imgSrc, index) {
            this.videoArr.splice(index, 1)
        },
        /**
         * 图片预览
         */
        $_showCretialsImg(image) {
            let images = []
            images.push(image)
            ImagePreview({
                images: images,
                showIndex: false,
                lazyLoad: false
            })
        },
        /**
         * 组件方法 获取文件流
         */
        async onRead(file) {
            let pic = file.target.files[0]
            this.files.name = pic.name // 获取文件名
            this.files.type = pic.type // 获取类型
            this.picValue = pic // 文件流
            this.imgPreview(this.picValue)
        },
        /**
         * 处理图片
         */
        imgPreview(file) {
            let self = this
            let Orientation
            //去获取拍照时的信息，解决拍出来的照片旋转问题
            Exif.getData(file, function() {
                Orientation = Exif.getTag(this, 'Orientation')
            })
            // 看支持不支持FileReader
            if (!file || !window.FileReader) return
            if (/^image/.test(file.type)) {
                // 创建一个reader
                let reader = new FileReader()
                // 将图片2将转成 base64 格式
                reader.readAsDataURL(file)
                // 读取成功后的回调
                reader.onloadend = function() {
                    let result = this.result
                    let img = new Image()
                    img.src = result
                    //判断图片是否大于500K,是就直接上传，反之压缩图片
                    if (this.result.length <= 500 * 1024) {
                        self.headerImage = this.result
                        self.imgArr[0].file = self.dataURLtoFile(self.headerImage)
                    } else {
                        img.onload = function() {
                            let data = self.compress(img, Orientation)
                            self.headerImage = data
                            self.imgArr[self.imgArr.length - 1].file = self.dataURLtoFile(self.headerImage)
                        }
                    }
                }
            }
        },
        /**
         * 压缩图片
         */
        compress(img, Orientation) {
            let canvas = document.createElement('canvas')
            let ctx = canvas.getContext('2d')
            //瓦片canvas
            let tCanvas = document.createElement('canvas')
            let tctx = tCanvas.getContext('2d')
            // let initSize = img.src.length;
            let width = img.width
            let height = img.height
            //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
            let ratio
            if ((ratio = (width * height) / 4000000) > 1) {
                ratio = Math.sqrt(ratio)
                width /= ratio
                height /= ratio
            } else {
                ratio = 1
            }
            canvas.width = width
            canvas.height = height
            //    铺底色
            ctx.fillStyle = '#fff'
            ctx.fillRect(0, 0, canvas.width, canvas.height)
            //如果图片像素大于100万则使用瓦片绘制
            let count
            if ((count = (width * height) / 1000000) > 1) {
                count = ~~(Math.sqrt(count) + 1) //计算要分成多少块瓦片
                //      计算每块瓦片的宽和高
                let nw = ~~(width / count)
                let nh = ~~(height / count)
                tCanvas.width = nw
                tCanvas.height = nh
                for (let i = 0; i < count; i++) {
                    for (let j = 0; j < count; j++) {
                        tctx.drawImage(
                            img,
                            i * nw * ratio,
                            j * nh * ratio,
                            nw * ratio,
                            nh * ratio,
                            0,
                            0,
                            nw,
                            nh
                        )
                        ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh)
                    }
                }
            } else {
                ctx.drawImage(img, 0, 0, width, height)
            }
            //修复ios上传图片的时候 被旋转的问题
            if (Orientation != '' && Orientation != 1) {
                switch (Orientation) {
                    case 6: //需要顺时针（向左）90度旋转
                        this.rotateImg(img, 'left', canvas)
                        break
                    case 8: //需要逆时针（向右）90度旋转
                        this.rotateImg(img, 'right', canvas)
                        break
                    case 3: //需要180度旋转
                        this.rotateImg(img, 'right', canvas) //转两次
                        this.rotateImg(img, 'right', canvas)
                        break
                }
            }
            //进行最小压缩
            let ndata = canvas.toDataURL('image/jpeg', 0.5) //canvas.toDataURL(mimeType, qualityArgument) qualityArgument默认为0.92
            tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0
            return ndata
        },
        /**
         * 旋转图片
         */
        rotateImg(img, direction, canvas) {
            //最小与最大旋转方向，图片旋转4次后回到原方向
            const min_step = 0
            const max_step = 3
            if (img == null) return
            //img的高度和宽度不能在img元素隐藏后获取，否则会出错
            let height = img.height
            let width = img.width
            let step = 2
            if (step == null) {
                step = min_step
            }
            if (direction == 'right') {
                step++
                //旋转到原位置，即超过最大值
                step > max_step && (step = min_step)
            } else {
                step--
                step < min_step && (step = max_step)
            }
            //旋转角度以弧度值为参数
            let degree = (step * 90 * Math.PI) / 180
            let ctx = canvas.getContext('2d')
            switch (step) {
                case 0:
                    canvas.width = width
                    canvas.height = height
                    ctx.drawImage(img, 0, 0)
                    break
                case 1:
                    canvas.width = height
                    canvas.height = width
                    ctx.rotate(degree)
                    ctx.drawImage(img, 0, -height)
                    break
                case 2:
                    canvas.width = width
                    canvas.height = height
                    ctx.rotate(degree)
                    ctx.drawImage(img, -width, -height)
                    break
                case 3:
                    canvas.width = height
                    canvas.height = width
                    ctx.rotate(degree)
                    ctx.drawImage(img, -width, 0)
                    break
            }
        },

        /**
         * 将base64转换为文件
         */
        dataURLtoFile(dataurl) {
            var arr = dataurl.split(','),
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n)
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new File([u8arr], this.files.name, {
                type: this.files.type
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/mixin';
// #service-declaration-container {
// height: 100%;
// width: 100vw;
// flex-direction: column;
.van-uploader__upload {
    @include wh(vw(80), vw(80));
}
.van-uploader__preview-image {
    @include wh(vw(80), vw(80));
}
// @include fja(flex-start, flex-start);

// -webkit-user-select: none;
// user-select: none;
// -webkit-touch-callout: none;
#headerMenuBox {
    display: flex;
    flex-direction: column;
    .nav-btn_left {
        @include wh(vw(44), vw(44));
        display: block;
        background: transparent url('../../assets/images/left_arrow_W.png') no-repeat center center;
        background-size: vw(10), vw(18);
    }
    .nav-btn_right {
        @include wh(vw(44), vw(44));
        @include fja(center, center);
        color: #ffffff;
        font-size: vw(12);
    }
}

.picture1 {
    display: flex;
    flex-direction: row;
    // padding-right: vw(15);
    flex-wrap: wrap;
    width: 95vw;
    margin-left: vw(-10);
    .delete_img {
        width: vw(16);
        height: vw(16);
    }
}
.pp {
    flex-wrap: wrap;

    display: flex;
    flex-direction: row;
}
.pictureOne {
    display: flex;
    position: relative;
    flex-wrap: wrap;
    @include wh(vw(80), vw(80));

    @include fja(flex-end, flex-start);
    // flex-direction: column;
    // padding-right: vw(70);
    // margin: vw(10) vw(0) vw(10) vw(10);
    // margin-right: vw(15);
    margin-left: vw(10);
    margin-top: vw(10);
    span {
        font-size: vw(10);
        color: #999999;
        margin-top: vw(6);
        margin-right: 0;
    }
    .img {
        width: vw(27);
        height: vw(24);
    }
    .img1 {
        @include wh(vw(80), vw(80));
    }
}
.roundTag {
    position: absolute;
    // @include fja(flex-start, flex-start);
    z-index: 999;
    width: vw(10);
    // height: vw(20);
    margin-top: vw(-30);
    margin-left: vw(25);
}
.picture_default1 {
    @include wh(vw(80), vw(80));
    display: flex;
    flex-wrap: wrap;
    // border: 1px dashed #cccccc;
    @include fja(center, center);
    flex-direction: column;
    margin-left: vw(10);
    margin-top: vw(10);
    .upload_span {
        font-size: vw(10) !important;
        color: #999999 !important;
        margin-top: vw(6);
        margin-right: 0 !important;
    }
    .img {
        @include wh(vw(80), vw(80));
    }
    .img1 {
        @include wh(vw(80), vw(80));
    }
}

.videoButton1 {
    width: 100%;
    height: 100%;
    position: absolute;
    @include fja(center, center);
}
.videoImgAn {
    @include wh(vw(80), vw(80));
    object-fit: fill;
}
.videoImg {
    @include wh(vw(80), vw(80));

    background-color: black;
}
.videoImgios {
    @include wh(vw(80), vw(80));
    // object-fit: contain;
}
.videoPlay {
    // background-color: #463330;
    position: absolute;
    width: vw(30);
}
.pictureBox {
    @include fja(flex-start, flex-start);
    .label {
        margin-top: vw(10);
    }
}
.problem {
    @include fja(flex-start, flex-start);
    .label {
        margin-top: vw(10);
    }
}

.video-bottom-text {
    @include fja(center, center);
    margin-top: vw(20);
    font-size: vw(20);
    color: #999999;
}
.video {
    margin-left: vw(80);
    flex: 1;
    padding: 0 vw(16);
    height: vw(40);
    border-radius: vw(2);
    border: solid vw(1) #cccccc;
    border-top-width: 0;
    border-top-left-radius: 0;
    font-size: vw(14);
    outline-color: invert;
    outline-style: none;
    outline-width: 0px;
    text-shadow: none;
    -webkit-appearance: none;
    user-select: text;
    -webkit-user-select: text;
    outline-color: transparent;
    box-shadow: none;
    @include fja(center, center);
}
.video-audio {
    width: 100%;
    @include fja(space-between, center);
    // height: vw(5);
    // margin-top: vw(10); // margin: 0 vw(16);
    // @include fja(center, center);
    audio {
        width: 100%;
    }
    .box {
        @include fja(flex-start, center);
    }
    .time {
        color: #999;
        font-size: vw(12);
        margin-left: vw(10);
    }
    .video-audio-ic {
        width: vw(16);
        height: vw(20);
    }
    .ic_waveform_box {
        background-color: #e3effb;
        width: vw(30);
        height: vw(20);
        margin-left: vw(8);
        border-radius: vw(10);
        @include fja(center, center);
        .video-waveform-ic {
            height: vw(10);
            width: vw(11);
        }
    }
}
.video-img {
    width: vw(16);
    // height: vw(20);
}
.footer {
    @include fja(center, center);
    width: 100%;
    background-color: #fff;
    height: vw(60);
    .submit {
        width: vw(359);
        height: vw(44);
    }

    span {
        position: absolute;
        font-size: vw(16);
        color: #fff;
        line-height: vw(16);
    }
}
.showVideo {
    margin-top: vw(30);
    @include fja(center, center);
}
.video_no {
    // -webkit-touch-callout: none;
    width: vw(80);
    height: vw(80);
}
.ios_video_no {
    pointer-events: none;
}
.loadingStyle {
    // background-color: pink;
    flex: 1;
    width: 100%;
    height: 100%;
    display: flex;
    // justify-content: center;
    z-index: 99999;
    position: absolute;
    @include fja(center, center);
    .loadingInnerStyle {
        padding: 20px;
        background-color: #666666;
        border-radius: 8px;
    }
}
.item {
    display: flex;
    position: absolute;
    z-index: 9;
}
.item1 {
    // margin-top: vw(-43);
    z-index: 999;
}
.aa {
    user-select: none;
    -webkit-touch-callout: none;
}
// .el-badge__content {
//   z-index: 999999;
// }
// }
</style>
